import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Alert extends Component {

    static propTypes = {
        alert: PropTypes.object.isRequired,
        acknowledge: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    }

    componentDidMount()
    {
        const { acknowledge } = this.props
        const delay = 3500

        this.timer = setTimeout(() => {
            acknowledge()
        }, delay)
    }

    render() {
        const { level, message } = this.props.alert
        const { acknowledge, t } = this.props

        return (
            <div className={`alert alert-${level} alert-dismissible`}>
                { typeof(message) === 'object' ? message : t(message)}
                <button type="button" className="close" aria-label="Close" onClick={acknowledge}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        );
    }
}

export default withTranslation()(Alert)
